import {
  Sekcja,
  Opis,
  Elementy,
  PodpisJustyna,
  PodpisPawel,
  Justyna,
  Pawel,
  WyksztalcenieJustyna,
  WyksztalceniePawel,
  ZdjeciePawel,
  ZdjecieJustyna,
  Paragraf,
  Informacja,
  Naglowek,
  Podnaglowek,
} from "./styled";
import JustynaZdjecie from "../../../images/justyna-zdjecie.webp";
import PawelZdjecie from "../../../images/pawel-zdjecie.webp";

const DlaczegoMy = () => (
  <>
    <Sekcja id="dlaczego-my">
      <Opis>
        <p className="eyebrow">Poznaj Serce Finansów</p>
        <h2>Poznaj Pawła i Justynę</h2>
        <p>Biuro w Suwałkach. Obsługa online w całej Polsce. Najpierw poznajemy Twoją sytuację, cel i termin, a później układamy plan działania.</p>
        <p><strong>Porównujemy możliwości, pilnujemy dokumentów i tłumaczymy decyzje prostym językiem.</strong></p>
        <p>Działamy jako pośrednicy wpisani do właściwych rejestrów Komisji Nadzoru Finansowego. Zajmujemy się finansowaniem hipotecznym i konsumenckim, a także pośrednictwem ubezpieczeniowym.</p>
        <Paragraf>
          <strong>Wiesz, co dzieje się na każdym etapie.</strong>
        </Paragraf>
      </Opis>
      <Elementy>
        <ZdjecieJustyna
          src={JustynaZdjecie}
          alt="Justyna Kowalewska, Serce Finansów Suwałki"
          width="323"
          height="538"
          loading="lazy"
          decoding="async"
        />
        <PodpisJustyna>
          <Justyna>
            <strong>
              Justyna <br /> Kowalewska
            </strong>
          </Justyna>
          <WyksztalcenieJustyna>
            Magister Finansów i Rachunkowości ze Szkoły Głównej Handlowej w
            Warszawie
          </WyksztalcenieJustyna>
        </PodpisJustyna>
        <PodpisPawel>
          <Pawel>
            <strong>
              Paweł <br /> Kowalewski
            </strong>
          </Pawel>
          <WyksztalceniePawel>
            Absolwent programu MBA w Wyższej Szkole Biznesu National Louis
            University
          </WyksztalceniePawel>
        </PodpisPawel>
        <ZdjeciePawel
          src={PawelZdjecie}
          alt="Paweł Kowalewski, Serce Finansów Suwałki"
          width="334"
          height="547"
          loading="lazy"
          decoding="async"
        />
      </Elementy>
    </Sekcja>
    <Informacja>
      <div>
        <Naglowek>9 lat</Naglowek>
        <Podnaglowek>doświadczenia w branży</Podnaglowek>
      </div>
      <div>
        <Naglowek>Ponad 1000</Naglowek>
        <Podnaglowek>obsłużonych klientów</Podnaglowek>
      </div>
      <div>
        <Naglowek>0 zł</Naglowek>
        <Podnaglowek>za konsultacje i obsługę kredytową; wynagrodzenie wypłaca bank</Podnaglowek>
      </div>
      <div>
        <Naglowek>Wiele banków</Naglowek>
        <Podnaglowek>porównanych w jednym miejscu</Podnaglowek>
      </div>
    </Informacja>
  </>
);

export default DlaczegoMy;

